import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  getTokenValue,
  Text,
  Token,
  XStack,
  YStack,
} from 'tamagui';

interface DisconnectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCancel: () => void;
  onDisconnect?: () => void;
  modalAction: 'disconnect' | 'reset';
}

export const DisconnectDialog: React.FC<DisconnectDialogProps> = ({
  open,
  onOpenChange,
  onCancel,
  onDisconnect,
  modalAction,
}) => {
  const { t } = useTranslation();

  const gradientStartColor = getTokenValue('$errorGradientStart' as Token, 'color') || '#F43C3F';
  const gradientEndColor = getTokenValue('$errorGradientEnd' as Token, 'color') || '#D12929';
  const background = `linear-gradient(135deg, ${gradientStartColor} 0%, ${gradientEndColor} 100%)`;

  let title = '';
  let description = '';
  let buttonLabel = '';

  switch (modalAction) {
    case 'reset':
      title = t('settings.wifi.resetWifi');
      description = t('settings.wifi.resetWifiDescription');
      buttonLabel = t('settings.wifi.reset');
      break;
    case 'disconnect':
    default:
      title = t('settings.wifi.disconnectFromWifi');
      description = t('settings.wifi.disconnectFromWifiDescription');
      buttonLabel = t('settings.wifi.disconnect');
      break;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          position="absolute"
          left={0}
          top={0}
          width="100%"
          height="100%"
          backgroundColor="rgba(0,0,0,0.4)"
          zIndex={99999}
        />
        <DialogContent
          bordered
          elevate
          height="330"
          width="751px"
          padding="$6"
          backgroundColor="$background"
          borderRadius={16}
          alignItems="flex-start"
          gap="16px"
          zIndex={100000}
          position="absolute"
          left="584.5px"
          top="75px">
          <DialogTitle
            fontSize="$8"
            color="$white12"
            padding={0}
            fontWeight="700"
            lineHeight="58px">
            {title}
          </DialogTitle>
          <YStack gap="$6">
            <Text fontSize="36px">{description}</Text>
            <XStack gap="$3">
              <Button
                onPress={onDisconnect}
                padding="$4"
                width="208px"
                height="72px"
                borderRadius={36}
                background={background}>
                <Text fontSize="$8.5" fontWeight="$4">
                  {buttonLabel}
                </Text>
              </Button>
              <Button
                onPress={onCancel}
                borderRadius={36}
                height="72px"
                width="134px"
                backgroundColor={'transparent'}>
                <Text fontSize="$8.5" fontWeight="$4">
                  {t('common.cancel')}
                </Text>
              </Button>
            </XStack>
          </YStack>
        </DialogContent>
      </Dialog.Portal>
    </Dialog>
  );
};
